"use client";
import { useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import useBrowseJobsFiltersStore from "@store/browseJobsFiltersStore";

const ClientSideFilters = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    jobTypeFilters,
    jobCategoryFilters,
    dateFilters,
    range,
    selectedCountries,
    selectedCountriesStates,
    selectedExperiences,
    resetCount,
  } = useBrowseJobsFiltersStore();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const queryParams = new URLSearchParams(searchParams.toString());

      if (jobTypeFilters.length > 0) {
        queryParams.set("jobType", jobTypeFilters.join(","));
      } else {
        queryParams.delete("jobType");
      }

      if (jobCategoryFilters.length > 0) {
        queryParams.set("category", jobCategoryFilters.join(","));
      } else {
        queryParams.delete("category");
      }

      if (dateFilters.length > 0) {
        queryParams.set("datePosted", dateFilters);
      } else {
        queryParams.delete("datePosted");
      }

      if (range.from !== 0 || range.to !== 0) {
        queryParams.set("salaryFrom", range.from.toString());
        queryParams.set("salaryTo", range.to.toString());
      } else {
        queryParams.delete("salaryFrom");
        queryParams.delete("salaryTo");
      }

      if (selectedCountries.length > 0) {
        queryParams.set("country", selectedCountries.join(","));
      } else {
        queryParams.delete("country");
      }

      if (selectedCountriesStates.length > 0) {
        queryParams.set("state", selectedCountriesStates.join(","));
      } else {
        queryParams.delete("state");
      }

      if (selectedExperiences.length > 0) {
        queryParams.set("jobExperience", selectedExperiences.join(","));
      } else {
        queryParams.delete("jobExperience");
      }

      router.replace(`/jobs?${queryParams.toString()}`);
    }, 300); // Adjust the debounce delay as needed

    return () => clearTimeout(timeoutId);
  }, [
    jobTypeFilters,
    jobCategoryFilters,
    dateFilters,
    range,
    selectedCountries,
    selectedCountriesStates,
    selectedExperiences,
    resetCount,
  ]);
  return null;
};

export default ClientSideFilters;
